import { useState } from "react";
import { Mail } from "lucide-react";
import { Modal } from "@/components/ds/Modal";
import { HubspotNewsletterForm } from "./HubspotNewsletterForm";


interface Props {
  /** Origin label sent to HubSpot (pageName suffix). */
  source: string;
  /** Button label. */
  label?: string;
  /** Optional extra classes on the trigger button. */
  className?: string;
}

/**
 * Renders an "Assinar" button. When clicked, opens a modal with the full
 * HubSpot newsletter form (firstname, lastname, email + hidden UTMs / page).
 */
export function NewsletterSubscribeButton({
  source,
  label = "Assinar newsletter",
  className,
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={
          className ??
          "w-full h-11 px-5 rounded-xl bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors inline-flex items-center justify-center gap-2"
        }
      >
        <Mail className="w-4 h-4" />
        {label}
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={
          <span className="inline-flex items-center gap-2">
            <Mail className="w-4 h-4 text-primary" />
            Assine a newsletter da Logcomex.ai
          </span>
        }
        description="Receba toda quinta-feira a curadoria de artigos, alertas regulatórios e indicadores de comex."
      >
        <HubspotNewsletterForm source={source} />
      </Modal>
    </>
  );
}
